import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BHSurveyOptionTree extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BHSurveyOptionTree'
  // Define default properties here
  static instanceDefaults() {
    return {};
  }
}
const servicePath = '/bh-survey-option-tree';
const servicePlugin = makeServicePlugin({
  Model: BHSurveyOptionTree,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [async context => {
      context.params.query.$and = [
        { set_name: { $ne: '' } }
      ];
      return context;
    } ],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [ async context => {
      const { app, result } = context;

      // console.log(app, result);

      await Promise.all(result.data.map(async i => {
        i.parsedData = [];
        
        // Check if data exists and is valid JSON
        if (!i.data || typeof i.data !== 'string' || i.data.trim() === '') {
          return;
        }
        
        try {
          const data = JSON.parse(i.data);
          for (let item of Object.keys(data)) {
            const key = await app.service('bh-survey-options').get(item);

            i.parsedData.push({
              key,
              yes: await Promise.all(data[item].yes.map(i => {
                return app.service('bh-survey-options').get(i);
              })),
              no: await Promise.all(data[item].no.map(i => {
                return app.service('bh-survey-options').get(i);
              }))
            })
          }
        } catch (error) {
          console.error('Failed to parse survey option tree data:', error);
          // Keep parsedData as empty array
        }

      }));

      return context;
    } ],
    get: [
      async context => {
        const { app, result } = context;
  
        result.parsedData = [];
        
        // Check if data exists and is valid JSON
        if (!result.data || typeof result.data !== 'string' || result.data.trim() === '') {
          return context;
        }
        
        try {
          const data = JSON.parse(result.data);
          for (let item of Object.keys(data)) {
            const key = await app.service('bh-survey-options').get(item);

            result.parsedData.push({
              key,
              yes: await Promise.all(data[item].yes.map(i => {
                return app.service('bh-survey-options').get(i);
              })),
              no: await Promise.all(data[item].no.map(i => {
                return app.service('bh-survey-options').get(i);
              }))
            })
          }
        } catch (error) {
          console.error('Failed to parse survey option tree data:', error);
          // Keep parsedData as empty array
        }
  
        return context;
      }
    ],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin